import { render, staticRenderFns } from "./RouteTable.vue?vue&type=template&id=62fa3892"
import script from "./RouteTable.vue?vue&type=script&lang=js"
export * from "./RouteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports